import { useContext } from "react";
import { AIRoleBuilderContext } from "components/Missions/Roles/AIRoleBuilder/AIRoleBuilderContext";

/**
 * useAIRoleBuilderContext - Hook to access the AI Role Builder context
 * Throws error if used outside provider
 */
export default function useAIRoleBuilderContext() {
  const context = useContext(AIRoleBuilderContext);

  if (!context) {
    throw new Error("useAIRoleBuilderContext must be used within AIRoleBuilderProvider");
  }

  return context;
}
